module.exports = import('./openhps-core.es.min.js');